import BorderedContainer from './BorderedContainer';

export default BorderedContainer;
